export default {
  customerRequest: {
    _tag: 'CSidebarNavItem',
    name: 'notifications',
    phrase: 'customer-request',
    to: '/customer-request',
    order: 2,
    icon: 'fa-regular fa-user',
   roles: ['Admin','Sub Admin'],
  },
}
